<template>
    <article class="card-cac-tour">
        <a :href="item.link" target="_blank" class="card-link image-link">
            <div class="image-wrapper">
                <mess-image v-if="item.image" :src="item.image" :width="350" />
            </div>

            <div class="content">
                <h3 class="card-header" v-if="item.title" v-html="item.title"></h3>
                <p class="gray-tag" v-if="item.type" v-html="item.type"></p>
                <p class="description small-book" v-if="item.description" v-html="getDesc(item.description)"></p>
            </div>
        </a>
    </article>
</template>

<script setup>
    const props = defineProps({
        item: {
            type: Object,
            required: false,
        },
    });

    const { item } = toRefs(props);

    const getDesc = (description) => {
        const descArr = description.split(' ');
        return descArr.length > 24 ? descArr.slice(0, 14).join(' ') + '...' : description;
    };
</script>

<style lang="scss" scoped>
    .card-cac-tour {
        height: 100%;
        .card-link {
            display: flex;
            position: relative;
            height: 100%;
        }

        .image-wrapper {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 35%;
            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
                object-position: center;
            }
        }

        .content {
            border: 1px solid #9d9fa2;
            border-left: 0;
            width: 65%;
            margin-left: auto;
            padding: 16px;
        }
    }
</style>
